const RECENT_KEY = 'stockai_recent_stocks';
const RECENT_MAX = 8;

export const STOCKAI_PREFIX = process.env.REACT_APP_STOCKAI_ONLY === '1' ? '' : '/stockai';

export function getNaverFinanceUrl(symbol) {
  if (!symbol) return 'https://finance.naver.com/';
  return `https://finance.naver.com/item/main.naver?code=${symbol}`;
}

/** 주문/검색/추천/포트폴리오 공통 종목 shape */
export function normalizeSelectedStock(item = {}, source = 'search') {
  const symbol = item.symbol || '';
  const action = item.orderType || item.order_type || item.action;
  return {
    symbol,
    name: item.name || item.stock_name || item.stockName || symbol,
    source: item.source || source,
    confidence: item.confidence ?? null,
    currentPrice: item.currentPrice ?? item.price ?? 0,
    changeRate: item.changeRate ?? item.profit_loss_rate ?? null,
    quantity: item.quantity ?? null,
    reason: item.reason || '',
    externalUrl: getNaverFinanceUrl(symbol),
    orderType: action === 'sell' ? 'sell' : 'buy',
  };
}

export function saveRecentStock(stock) {
  if (!stock?.symbol) return;
  try {
    const entry = normalizeSelectedStock(stock, stock.source || 'recent');
    const raw = localStorage.getItem(RECENT_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const filtered = list.filter((s) => s.symbol !== entry.symbol);
    const next = [entry, ...filtered].slice(0, RECENT_MAX);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}

export function loadRecentStocks() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function formatKrw(n) {
  return `${Math.round(n || 0).toLocaleString()}원`;
}

/** React Router navigate로 주문 화면 이동 */
export function goToTrade(navigate, stock, orderType = 'buy') {
  const selected = normalizeSelectedStock(
    { ...stock, orderType },
    stock.source || 'search'
  );
  saveRecentStock(selected);
  navigate(`${STOCKAI_PREFIX}/trade`, { state: { selectedStock: selected } });
}
